import { AdditionalActionProps } from "@sis/react-library";
import { Track } from "../../../interfaces/dtos/track";
import { TrackState } from "../../../redux/track/trackSlice";
import { Avatar, Theme } from "@mui/material";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CheckBoxTwoToneIcon from '@mui/icons-material/CheckBoxTwoTone';
import DisabledByDefaultTwoToneIcon from '@mui/icons-material/DisabledByDefaultTwoTone';

export const trackActionKeys = {
    upload: "upload",
    setActive: "setActive",
    setInactive: "setInactive"
}

export const trackAdditionalActions = (state: TrackState, theme: Theme): AdditionalActionProps<Track>[] => {
    const isUploadingFile = state.uploadingPerc !== undefined && state.uploadingPerc !== 100;
    return [
        { space: 20, position: "beforeDelete" },
        {
            key: trackActionKeys.upload,
            icon: isUploadingFile ?
                <Avatar><span style={{ fontSize: '10px', color: theme.palette.grey[400] }}>{state.uploadingPerc}%</span></Avatar> :
                <FileUploadIcon />,
            busy: state.uploadingPerc === 100,
            isAvatar: isUploadingFile, disabled: () => isUploadingFile,
            tooltip: () => "Upload track codes from an Excel file", position: "beforeNew"
        },
        { space: 20 },
        {
            key: trackActionKeys.setActive, icon: <CheckBoxTwoToneIcon />,
            colour: theme.palette.success.light, busy: state.busySettingActive,
            tooltip: (selected) => additionalActionsTooltip(selected, true),
            disabled: (selected) => additionalActionsDisabled(selected, true)
        },
        {
            key: trackActionKeys.setInactive, icon: <DisabledByDefaultTwoToneIcon />,
            colour: theme.palette.warning.light, busy: state.busySettingInactive,
            tooltip: (selected) => additionalActionsTooltip(selected, false),
            disabled: (selected) => additionalActionsDisabled(selected, false)
        }
    ];
}

const containsStatus = (tracksSelected: Track[], isTrackActive: boolean) => {
    return tracksSelected.some((t) => t.isTrackActive === isTrackActive);
}

const additionalActionsTooltip = (tracksSelected: Track[], isTrackActive: boolean) => {
    const tooltip = `Set as ${isTrackActive ? "active" : "inactive"}`;
    return containsStatus(tracksSelected, isTrackActive) ?
        <>{tooltip}<br />(disabled as you have selected tracks that are already active)</> :
        tooltip;
}

const additionalActionsDisabled = (tracksSelected: Track[], isTrackActive: boolean) => {
    return tracksSelected.length === 0 || containsStatus(tracksSelected, isTrackActive);
}